import React from 'react'

import classes from './EmpProfileInfoItem.scss'

import InputGroup from '../../../../../../../UI/Forms/InputGroup/InputGroup'
import { calculateWorkingAge } from '../../../../../../../../helpers/utils'
import { withTranslate } from 'react-redux-multilingual'

const empProfileInfoItem = ({ changed, formKey, formAttrs, edit, translate }) => {
  let formItem = (
    <InputGroup
      label={formAttrs.label}
      inputType={formAttrs.elementType}
      configs={formAttrs.elementConfig}
      invalid={!formAttrs.valid}
      validations={formAttrs.validation}
      touched={formAttrs.touched}
      changed={changed}
      inputValue={formAttrs.value}
      validationError={formAttrs.error}
      noMargin
    />
  )

  if (formKey === 'working_age') {
    let workingAgeData = calculateWorkingAge(formAttrs.value)
    let elementConfig = {
      readOnly: true
      // disabled: !edit
    }
    formItem = (
      <div className={classes.WorkingAgeWrapper}>
        <div className={classes.WorkingAgeLabel}>{translate('workingAge')}</div>
        <div className={classes.WorkingAge}>
          <span className={classes.WorkingAgeInfo}>
            <InputGroup
              label={translate('year')}
              configs={elementConfig}
              inputValue={workingAgeData.year || 0}
              inputClass={classes.WorkingAgeInput}
              labelClass={classes.WorkingAgeItemLabel}
              noMargin
            />
          </span>
          <span className={classes.WorkingAgeInfo}>
            <InputGroup
              label={translate('month')}
              configs={elementConfig}
              inputValue={workingAgeData.month || 0}
              inputClass={classes.WorkingAgeInput}
              labelClass={classes.WorkingAgeItemLabel}
              noMargin
            />
          </span>
          <span className={classes.WorkingAgeInfo}>
            <InputGroup
              label={translate('day')}
              configs={elementConfig}
              inputValue={workingAgeData.day || 0}
              inputClass={classes.WorkingAgeInput}
              labelClass={classes.WorkingAgeItemLabel}
              noMargin
            />
          </span>
        </div>
      </div>
    )
  }

  return <div className={classes.EmpProfileInfoItem}>{formItem}</div>
}

export default withTranslate(empProfileInfoItem)
